import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Specialties } from './components/Specialties';
import { ConsultationForm } from './components/ConsultationForm';
import { Footer } from './components/Footer';
import { PrivacyPolicy } from './components/PrivacyPolicy';
import { TermsOfService } from './components/TermsOfService';
import { mockData } from './mock';

const HomePage = () => {
  const [isConsultationOpen, setIsConsultationOpen] = useState(false);

  const handleConsultationClick = () => {
    setIsConsultationOpen(true);
  };

  const handleConsultationClose = () => {
    setIsConsultationOpen(false);
  };

  return (
    <>
      <main>
        <Hero onConsultationClick={handleConsultationClick} />
        <Specialties specialties={mockData.specialties} />
        <Services services={mockData.services} />
      </main>
      <Footer contact={mockData.contact} />
      <ConsultationForm 
        isOpen={isConsultationOpen}
        onClose={handleConsultationClose}
        formData={mockData}
      />
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;